import React from "react";
import ReactEcharts from "echarts-for-react";
type LineChartProps = {
  data: { name: string; values: { x: string; y: number }[] }[];
  title: string;
  yAxisName: string;
  height: string;
};

export const mockData = [
  {
    name: "Set 1",
    values: [
      { x: "jan", y: 15 },
      { x: "feb", y: 18 },
      { x: "mar", y: 22 },
      { x: "apr", y: 30 },
      { x: "may", y: 25 },
    ],
  },
  {
    name: "Target",
    values: [
      { x: "jan", y: 20 },
      { x: "feb", y: 23 },
      { x: "mar", y: 27 },
      { x: "apr", y: 35 },
      { x: "may", y: 30 },
      { x: "jun", y: 33 },
      { x: "jul", y: 45 },
      { x: "aug", y: 43 },
      { x: "sep", y: 50 },
      { x: "oct", y: 47 },
      { x: "nov", y: 55 },
    ],
  },
];

const mappingMonth: any = {
  jan: "ม.ค.",
  feb: "ก.พ.",
  mar: "มี.ค.",
  apr: "เม.ย.",
  may: "พ.ค.",
  jun: "มิ.ย.",
  jul: "ก.ค.",
  aug: "ส.ค.",
  sep: "ก.ย.",
  oct: "ต.ค.",
  nov: "พ.ย.",
  dec: "ธ.ค.",
};

export const LineChart: React.FC<LineChartProps> = ({
  data,
  title,
  yAxisName,
  height,
}) => {
  const options = {
    title: {
      text: title,
    },
    // grid: {
    //     show: true,
    // },
    xAxis: {
      type: "category",
      data:
        data.length > 0 && data[1].values
          ? data[1].values.map((item) =>
              mappingMonth.hasOwnProperty(item.x)
                ? mappingMonth[item.x]
                : item.x
            )
          : [],
      //   axisTick: {
      //     length: 6,
      //     lineStyle: {
      //         color: 'gray'
      //     }
      // }
    },
    yAxis: {
      type: "value",
      name: yAxisName, // yAxis name prop
      splitLine: {
        lineStyle: {
          color: "lightgrey",
        },
      },
    },
    series:
      data.length > 0
        ? data.map((dataset, index) => ({
            name: dataset.name,
            data: dataset.values
              ? dataset.values.map((item, itemIndex) => ({
                  value: item.y,
                  symbol:
                    index === 1 && itemIndex === dataset.values.length - 1
                      ? "circle"
                      : "none", // Show circle only for the last item of series 1
                  symbolSize: 10, // Size of the dot
                }))
              : [],
            type: "line",
            markLine: {
              symbol: ["none", "none"],
              label: { show: false },
              lineStyle: { type: "solid", color: "lightgrey" },
              data: dataset.values
                ? dataset.values.map((item, itemIndex) => ({
                    xAxis: itemIndex + 1,
                  }))
                : [],
            },
            lineStyle: {
              type: index === 0 ? "dashed" : "solid",
              color: index === 0 ? "#FFA500" : "green", // Orange color for the second series
            },
            showSymbol: false,
            smooth: false,
            areaStyle:
              index === 1 ? { color: "green", opacity: 0.2 } : undefined,
          }))
        : [],
    tooltip: {
      trigger: "axis",
    },
    // legend: {
    //   data: data.length > 0 ? data.map((dataset) => dataset.name) : [],
    //   bottom: "5%",
    // },
  };

  return (
    <ReactEcharts option={options} style={{ height: height, width: "100%" }} />
  );
};
